import * as React from 'react';
export var useReactTreeApi = function () {
    return React.useRef();
};
//# sourceMappingURL=useReactTreeApi.js.map